import { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { MoreVertical, Pencil, Trash } from "lucide-react";

import styles from "./RecurringExceptionItem.module.css";

export const ChangeStatusButton = ({
  disabled,
  exceptionId,
  deleteException,
  editException,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div className={styles.changeStatusButtonWrapper}>
        <button
          id="sortBy"
          aria-controls={open ? "sortBy" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          className={styles.sortByButton}
          disabled={disabled}
          aria-label="change status"
        >
          <MoreVertical size={16} width={16} height={16} />
        </button>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "12px",
              minWidth: "180px",
            },
          }}
          className={styles.menuItemWrapper}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <p className={styles.menuTitle} style={{ marginTop: "2px" }}>
            Actions
          </p>
          <MenuItem
            onClick={() => {
              handleClose();
              editException();
            }}
            className={styles.menuItem}
          >
            <button className={styles.editButton}>
              <Pencil
                size={18}
                width={18}
                height={18}
                className={styles.editIcon}
              />
              Edit
            </button>
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleClose();
              deleteException(exceptionId);
            }}
            className={styles.menuItem}
          >
            <button className={styles.deleteButton}>
              <Trash
                size={18}
                width={18}
                height={18}
                className={styles.deleteIcon}
              />
              Delete
            </button>
          </MenuItem>
        </Menu>
      </div>
    </>
  );
};
